import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upload-modal__inner" }
const _hoisted_2 = { class: "upload-modal__header" }
const _hoisted_3 = { class: "upload-modal__title-heading" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Project ", -1 /* HOISTED */)
const _hoisted_5 = { class: "upload-modal__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "upload-modal__upload-status" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "upload-modal__progress-bar" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "upload-modal__content upload-modal__content--video" }
const _hoisted_10 = {
  key: 0,
  class: "upload-modal__complete-message"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " This project is now complete and further uploading has been disabled. ", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "upload-modal__complete-message"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " Your files are being processed and will be available to view shortly. ", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, " Remember that uploads need to be approved by a PM or Lead Artist before they are visible to clients. ", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "upload-modal__files"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Filename"),
    /*#__PURE__*/_createElementVNode("th", null, "Asset"),
    /*#__PURE__*/_createElementVNode("th", null, "Artist")
  ])
], -1 /* HOISTED */)
const _hoisted_19 = {
  key: 1,
  class: "form__icon form__icon--down"
}
const _hoisted_20 = ["onUpdate:modelValue", "disabled"]
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  value: ""
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { colspan: "4" }
const _hoisted_27 = { class: "upload-modal__errors" }
const _hoisted_28 = {
  key: 0,
  class: "upload-modal__submit-bar"
}
const _hoisted_29 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_drag_drop = _resolveComponent("drag-drop")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Modal header "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "upload-modal__back",
        "aria-label": "Go back",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit( 'back-to-format-select' )))
      }, " Back "),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h2", _hoisted_5, _toDisplayString($props.project.title), 1 /* TEXT */)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["upload-modal__progress-wrapper", { 'invisible': $options.awaiting_upload }])
      }, _hoisted_8, 2 /* CLASS */)
    ]),
    _createCommentVNode(" Modal content "),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($props.project.project_status === 'completed' || $props.project.project_status === 'terminated')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : ($data.show_complete_message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  id: "image-upload",
                  class: _normalizeClass(["upload-modal__drag-drop flex", { 'upload-modal__drag-drop--hover': $data.hover }])
                }, [
                  ($data.uppy && $options.awaiting_upload)
                    ? (_openBlock(), _createBlock(_component_drag_drop, {
                        key: 0,
                        uppy: $data.uppy,
                        props: $data.uppy_config
                      }, null, 8 /* PROPS */, ["uppy", "props"]))
                    : _createCommentVNode("v-if", true),
                  (Object.keys( $data.files ).length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, (file, file_id) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: file_id }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(file.filename), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString($props.asset.title), 1 /* TEXT */),
                                _createElementVNode("td", null, [
                                  (!$options.awaiting_upload)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString($data.staff_list.find( artist => artist === file.artist ).label), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": $event => ((file.artist) = $event),
                                          class: _normalizeClass(["form__select form__select--stretch", { 'form__select--error': $data.errors[ file_id ] && $data.errors[ file_id ].artist }]),
                                          disabled: !$options.project_staff_list || !$options.project_staff_list.length
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.project_staff_list, (user) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: `artist-${ user.value }`,
                                              value: user.value
                                            }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_21))
                                          }), 128 /* KEYED_FRAGMENT */)),
                                          (!$options.project_staff_list || !$options.project_staff_list.length)
                                            ? (_openBlock(), _createElementBlock("option", _hoisted_22, " No artists on project "))
                                            : _createCommentVNode("v-if", true)
                                        ], 10 /* CLASS, PROPS */, _hoisted_20), [
                                          [_vModelSelect, file.artist]
                                        ]),
                                        (file.artist && Object.values( $data.files ).length > 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "form__copy-value",
                                              onClick: $event => ($options.copyArtistToAll( file.artist ))
                                            }, " Select artist for all ", 8 /* PROPS */, _hoisted_23))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                ]),
                                _createElementVNode("td", null, [
                                  ($options.awaiting_upload)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "upload-modal__remove-file",
                                        onClick: $event => ($options.removeFile( file_id ))
                                      }, null, 8 /* PROPS */, _hoisted_24))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]),
                              ($data.errors[ file_id ])
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                                    _createElementVNode("td", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.errors[ file_id ], (error, error_id) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: `error-${ error_id }`,
                                            class: "form__error"
                                          }, [
                                            _createElementVNode("p", null, _toDisplayString(error), 1 /* TEXT */)
                                          ]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createCommentVNode(" Modal submit bar "),
    (Object.keys( $data.files ).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("p", null, _toDisplayString($options.getTotalFileSize( $options.uppy_files )), 1 /* TEXT */),
          _createElementVNode("button", {
            class: "button button--fill",
            disabled: !$options.awaiting_upload,
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.submitUpload && $options.submitUpload(...args)))
          }, " Upload ", 8 /* PROPS */, _hoisted_29)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}